import React from 'react';

// Libellé + menu déroulant du site vitrine (.mkt-label / .mkt-input).
interface SelectFieldProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: React.ReactNode;
}

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  className = '',
  children,
  ...rest
}) => {
  const select = (
    <select className={['mkt-input', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </select>
  );
  if (!label) return select;
  return (
    <>
      <label className="mkt-label">{label}</label>
      {select}
    </>
  );
};

export default SelectField;
